import type { AxiosError } from 'axios';

export const errorMessagesFromStatus = {
  400: 'Você já possui uma inscrição ativa para este curso.',
  404: 'Oferta não está mais disponível.',
  422: 'Você atingiu o limite de inscrições em Cursos Gratuitos no mês. Entre em contato com o atendimento.',
};

export const errorMessagesFromRawMessage = {
  default: 'Ocorreu um erro ao processar o pagamento',
  address_number: 'Tivemos um problema ao registrar o seu endereço',
  email: 'Tivemos um problema ao registrar o seu email',
  payment_method: 'Tivemos um problema ao registrar o seu método de pagamento',
};

const knownErrorMessages = [
  errorMessagesFromStatus[400],
  errorMessagesFromStatus[404],
  errorMessagesFromStatus[422],
  errorMessagesFromRawMessage.default,
];

const extractErrorField = (rawMessage: string) => {
  // O backend retorna dois formatos: "source/field: message" ou "field: message"
  const beforeColon = rawMessage.split(':')[0];
  const afterSlash = beforeColon.split('/').pop();
  return afterSlash?.trim() ?? beforeColon.trim();
};

const extractErrorMessageFromRawMessage = (rawMessage: string) => {
  if (rawMessage.includes(errorMessagesFromStatus[400])) {
    return errorMessagesFromStatus[400];
  }

  const field = extractErrorField(rawMessage);

  if (field in errorMessagesFromRawMessage)
    return errorMessagesFromRawMessage[
      field as keyof typeof errorMessagesFromRawMessage
    ];

  return errorMessagesFromRawMessage.default;
};

const extractErrorMessageFromStatus = (status: number) => {
  return (
    errorMessagesFromStatus[status as keyof typeof errorMessagesFromStatus] ??
    ''
  );
};

export const getSubscriptionErrorMessage = (
  axiosError: AxiosError<{ data: { message: string } }>
) => {
  const rawMessage = axiosError.response?.data?.data?.message ?? '';
  const status = axiosError.response?.status;

  if (status === 400) {
    return extractErrorMessageFromRawMessage(rawMessage);
  }

  return extractErrorMessageFromStatus(status ?? 0);
};

export const getCheckoutErrorMessage = (
  axiosError: AxiosError<{ data: { message: string } }>
): string => {
  const rawMessage = axiosError.response?.data?.data?.message;

  if (!rawMessage) return errorMessagesFromRawMessage.default;

  return extractErrorMessageFromRawMessage(rawMessage);
};

export const handleSubscriptionError = (
  axiosError: AxiosError<{ data: { message: string } }>
) => {
  const errorMessage = getSubscriptionErrorMessage(axiosError);

  const isUnknownError = !knownErrorMessages.includes(errorMessage);

  return { errorMessage, isUnknownError };
};

export const handleCheckoutError = (
  axiosError: AxiosError<{ data: { message: string } }>
) => {
  const errorMessage = getCheckoutErrorMessage(axiosError);

  const isUnknownError = !knownErrorMessages.includes(errorMessage);

  return { errorMessage, isUnknownError };
};
